import * as React from 'react';

export interface GapProps {
  margin?: string;
  padding?: string;
}

const Gap: React.FC<GapProps> = ({ margin, padding, children }) => {
  return (
    <div
      style={{
        padding,
        margin
      }}
    >
      {children}
    </div>
  );
};

export default Gap;
